import * as Logrocket from 'logrocket';
import { Environment } from '../types';
import * as Sentry from '@sentry/react';

/* functions to log things wherever we want */

export const log: (msg: string) => void = (msg) => {
    if (process.env.NODE_ENV !== Environment.Production) {
        console.log(msg);
    } else {
        Logrocket.log(msg);
    }
};

export const warn: (msg: string) => void = (msg) => {
    if (process.env.NODE_ENV !== Environment.Production) {
        console.log(msg);
    } else {
        Logrocket.warn(msg);
        Sentry.captureMessage(msg);
    }
};

export const error: (e: Error) => void = (error) => {
    if (process.env.NODE_ENV !== Environment.Production) {
        console.log(error);
    } else {
        Logrocket.error(error);
        Sentry.captureException(error);
    }
};
